import { mapState } from 'vuex'
import { format, parse } from 'date-fns'

export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    TravelInsuranceForm: () =>
      import('~/components/layouts/travel-insurance-form/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      activeStep: 0,
      travelData: {},
      isSending: false
    }
  },
  computed: {
    ...mapState(['auth']),
    teamMember() {
      return this.$store.state.team.members[0]
    },
    simulationData() {
      return {
        company_id: 1,
        insured_name: this.travelData.firstName,
        insured_lastname: this.travelData.lastName,
        insured_email: this.travelData.email,
        insured_phone: this.travelData.phone.toString(),
        insured_dob: this.travelData.applicantDateOfBirth,
        start_date: format(
          parse(this.travelData.start_date, 'dd/MM/yyyy', new Date()),
          'yyyy-MM-dd'
        ),
        end_date: format(
          parse(this.travelData.end_date, 'dd/MM/yyyy', new Date()),
          'yyyy-MM-dd'
        ),
        country: this.travelData.country,
        applicants: this.travelData.numberOfApplicants
      }
    }
  },

  methods: {
    isStepActive(index) {
      return index === this.activeStep
    },

    goToNextStep() {
      this.$gtm.pushEvent({
        event:
          this.activeStep === 0
            ? 'travel_simulation_start'
            : 'travel_simulation_completed'
      })

      this.activeStep++
      window.scrollTo(0, 0)
    },

    submitForm() {
      if (this.isSending) {
        return
      }

      this.isSending = true

      this.sendToServer()
        .then((response) => {
          this.isSending = false

          this.$gtm.pushEvent({
            event: 'travel_simulation'
          })

          return this.handleSucessSubmission(response.data)
        })
        .catch((_error) => {
          this.isSending = false
        })
    },

    sendToServer() {
      return this.$axios.post(
        '/travelinsurance/createquote',
        this.simulationData,
        {
          headers: {
            'Content-type': 'application/json; charset=utf-8'
          },
          withCredentials: true
        }
      )
    },

    handleSucessSubmission(response) {
      this.saveSimulationOnStorage(response.uuid)
      this.saveSimulationData(this.simulationData)
      this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-viagem-resultados-id',
          params: {
            id: response.uuid
          }
        })
      )
    },
    saveSimulationData(simulationData) {
      return this.$store.commit('localStorage/SAVE_SIMULATION_DATA', {
        simulationData
      })
    },
    saveSimulationOnStorage(id) {
      if (this.auth.isLoggedIn) {
        return
      }

      return this.$store.commit(
        'localStorage/ADD_ANONYMOUS_TRAVEL_SIMULATION',
        {
          id
        }
      )
    }
  }
}
